import http from '@/http';
import router from '@/router';
import { v4 as uuid4 } from 'uuid';

// state
export const state = {
    response: {},
    answers: [],
};

// mutations
export const mutations = {
    START_ASSESSMENT(state, response) {
        state.answers = [];
        state.response = Object.assign({}, response);

        this._vm.$toasted.show(`${response.responseTime}ms`, { duration: 8000 });

        state.answers.push(response);
    },
    ANSWER_ITEM(state, response) {
        state.response = Object.assign({}, response);

        this._vm.$toasted.show(`${response.responseTime}ms`, { duration: 8000 });

        state.answers.push(response);
    },
    GO_BACK(state) {
        const answers = [...state.answers];

        // remove last answer
        answers.pop();

        // Now cache this value; as this are now the leading 'answers' given
        state.answers = [...answers];

        // Get the previous question
        const previous = answers.pop();

        // set the previous response as the current response so it may be answered again.
        state.response = Object.assign({}, previous);
    },
};

// getters
export const getters = {
    pre(state) {
        return state.response.ItemContext || '';
    },
    item(state) {
        return state.response.ItemTitle || '';
    },
    post(state) {
        return state.response.ItemDescription || '';
    },
    responseOptions(state) {
        return state.response.Responses || [];
    },
    score(state) {
        return state.response.ScoreInterpretations || [];
    },
};

// actions
export const actions = {
    start({ commit, rootState }) {
        const PatientID = uuid4();
        const SessionID = uuid4();

        http.post('ItemBank/GetItem', {
            'CustomerID': rootState.auth.response.customerID,
            'ItembankID': rootState.measures.measure.ID,
            PatientID,
            SessionID,
        }, { baseURL: rootState.auth.url }).then(response => {
            commit('START_ASSESSMENT', response);

            router.push('assessment');
        }).catch(error => {
            alert(error);
        });
    },
    answer({ commit, state, rootState }, responseOption) {
        http.post('ItemBank/UpdateResponse', {
            'CustomerID': rootState.auth.response.customerID,
            'ItembankID': state.response.ItembankID,
            'PatientID': state.response.PatientID,
            'SessionID': state.response.SessionID,
            'ItemID': state.response.ItemID,
            'RespondedID': responseOption,
        }, { baseURL: rootState.auth.url }).then(response => {
            commit('ANSWER_ITEM', response);
        }).catch(error => {
            alert(error);
        });
    },
    back({ commit }) {
        commit('GO_BACK');
    },
};
